import instance from "../../../../API/MainAPI";

export function GameProposalStepAvailabilityAPI(gameProposalId: number) {
  return instance.get(`/v1/labs/game-proposals/${gameProposalId}/step-availability`);
}

// export function GameProposalDetailsAPI(gameProposalId: number) {
//   return instance.get(`/v1/labs/game-proposals/${gameProposalId}`);
// }

